import { SezioneDTO } from '@framework/api-client';
import { IRootWidgetIdentifier, getAllRoots } from '@framework/engine';
import { useMemo } from 'react';

function typedGetAllRoot(
  allSections: SezioneDTO[] | null | undefined,
): IRootWidgetIdentifier[] {
  return getAllRoots(allSections);
}

export function useFillableAllRoots(
  allSections: SezioneDTO[] | null | undefined,
): IRootWidgetIdentifier[] {
  const allRoots: IRootWidgetIdentifier[] = useMemo(
    () => typedGetAllRoot(allSections),
    [allSections],
  );

  return allRoots;
}
